

import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="order-notes"
export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.onClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this.onClick)
  }

  onClick(event) {
    event.preventDefault();
    const form = this.closest('.order-notes-form');
    form.classList.toggle('--editing');
  }
}